import { useState } from 'react';
import { apiService } from '../services/api';

export const useContactForm = () => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    mobile: '',
    message: '',
    hotel: 'pettipetti'
  });
  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState(false);
  const [error, setError] = useState(null);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError(null);
    setSuccess(false);

    try {
      await apiService.submitContactForm(formData);
      setSuccess(true);
      setFormData({
        name: '',
        email: '',
        mobile: '',
        message: '',
        hotel: 'pettipetti'
      });
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  return {
    formData,
    loading,
    success,
    error,
    handleChange,
    handleSubmit
  };
};

